import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: calc(100vh - 62px) !important;
  width: 100%;
`;
